import React from 'react'
import { Grid } from '@material-ui/core'
import { Bar } from 'react-chartjs-2'

import Card from 'src/components/sharedComponents/Card/Card'
import CardBody from 'src/components/sharedComponents/Card/CardBody'
import CardHeader from 'src/components/sharedComponents/Card/CardHeader'
import * as Utils from 'src/utils/chartsUtils'

import { useStyles } from '../styles'
import TableAA from '../../Tables/TableAA'

const SreetMarketWorkCard = (props) => {
  const { totalWork = [], selectedDate, gTotalWork = [] } = props
  const classes = useStyles()

  return (
    <Card>
      <CardHeader>
        <div className={classes.center}>
          <div>
            <h3>Mercado TRABAJO</h3>
          </div>
          {`  `}
        </div>
      </CardHeader>
      <CardBody>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} lg={6}>
            <TableAA array={totalWork} selectedDate={selectedDate} disableAA />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <h3>Evolución TRABAJO en miles</h3>
            <br />
            <Bar
              data={Utils.simpleBarLine(
                gTotalWork,
                'Y',
                'CANT',
                'VARIACION',
                'Año',
              )}
              options={Utils.optionsSimpleBarChart}
            />{' '}
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  )
}

export default SreetMarketWorkCard
